export default __webpack_public_path__ + "static/media/right_arrow.4c6b0e7f.png";